<template>
  <section class="payment">
    <div class="payment__wrapper">
      <div class="payment__box">
        <Header />
        <el-row :gutter="48">
          <el-col :md="12">
            <Card />
          </el-col>
          <el-col :md="12">
            <Actions />
          </el-col>
        </el-row>
      </div>
      <button class="payment__back" @click="$router.back()">
        <svg-icon name="arrow-left" />
        Вернуться назад
      </button>
    </div>
  </section>
</template>

<script>
import Header from '@/components/Users/Payment/Header'
import Card from '@/components/Users/Payment/Card'
import Actions from '@/components/Users/Payment/Actions'

export default {
  components: { Actions, Card, Header },
  name: 'index'
}
</script>

<style scoped lang="scss">
.payment {
  background: $mercury;
  width: 100vw;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'PFCentroSansPro', sans-serif;

  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @include lg-and-down {
      padding: 24px 16px 48px;
    }
  }

  &__box {
    background: $white;
    box-shadow: 0 4px 20px rgba($mine-shaft, 0.05);
    border-radius: 16px;
    width: 1200px;
    padding: 24px 24px 48px;

    @include lg-and-down {
      width: 100%;
    }

    @include md-and-down {
      padding: 16px;
    }
  }

  &__back {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 0.35px;
    color: $french-gray;
    transition: 0.3s;
    margin-top: 24px;

    svg {
      transition: 0.3s;
      stroke: $french-gray;
      margin-right: 20px;
    }

    &:hover {
      color: $deepdark;

      svg {
        stroke: $deepdark;
      }
    }
  }
}
</style>
